import Head from "next/head";
import Script from "@/components/script";
import FaviconIco from "@/assets/images/favicon.ico";
import initHmt from "@/utils/hmt";

const PublicHead = () => {
  return (
    <>
      <Head>
        <meta name="renderer" content="webkit" />
        <title></title>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge,chrome=1"></meta>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=no, viewport-fit=cover"
        ></meta>
        <meta name="applicable-device" content="pc,mobile" />
        <meta name="referrer" content="no-referrer-when-downgrade"></meta>
        <link rel="icon" type="image/x-icon" href={FaviconIco.src} />
        <link rel="canonical" href="https://www.designkit.cn/ppt" />
      </Head>
      <Script id="init-hmt">{initHmt}</Script>
    </>
  );
};

export default PublicHead;
